import { supabase } from '../supabaseClient';
import { DYNAMIC_OPTION_TYPES, OTHER_OPTION } from '../constants/profileOptions';

export async function loadProfileOptions(userId) {
  if (!userId) throw new Error('Please sign in to load your profile options.');
  const types = Object.values(DYNAMIC_OPTION_TYPES);
  const [standard, personal] = await Promise.all([
    supabase.from('profile_option_master').select('type,label').is('created_by', null).in('type', types).order('label', { ascending: true }),
    supabase.from('user_profile_options').select('type,label').eq('user_id', userId).in('type', types).order('label', { ascending: true }),
  ]);
  if (standard.error) throw standard.error;
  if (personal.error) throw personal.error;
  const options = Object.fromEntries(types.map(type => [type, []]));
  for (const row of [...(standard.data || []), ...(personal.data || [])]) {
    const label = row.label?.trim();
    if (options[row.type] && label && label !== OTHER_OPTION && !options[row.type].some(value => value.toLowerCase() === label.toLowerCase())) {
      options[row.type].push(label);
    }
  }
  return options;
}
